import initSwiperCtaProducts from '../swipers/swiperCtaProducts';
import initSwiperCtaActus from '../swipers/swiperCtaActus';
import initSwiperArgs from '../swipers/swiperArgs';
import initSwiperLastsProjets from '../swipers/swiperLastsProjets';
import initSwiperTimeline from '../swipers/swiperTimeline';
import toggleSwiperActivityAreaPosts from '../swipers/swiperActivityAreaPosts';
import toggleSwiperCtaServices from '../swipers/swiperCtaServices';
import SwiperCtaJobs from '../swipers/swiperCtaJobs';
import toggleSwiperArgsLogiciels from '../swipers/swiperArgsLogiciels';

class Sliders {
    constructor() {
        this.swiperCtaJobs = new SwiperCtaJobs();
        this.swiperArgsLogiciels = null;
        this.checkScreenWidth = this.checkScreenWidth.bind(this);
        this.init();
    }

    init() {
        initSwiperCtaProducts();
        initSwiperLastsProjets();
        initSwiperCtaActus();
        initSwiperTimeline();
        initSwiperArgs();
        this.swiperCtaJobs.init();
        this.checkScreenWidth();
        window.addEventListener('resize', this.checkScreenWidth);
        document.addEventListener('DOMContentLoaded', () => {
            this.checkScreenWidth();
        });
    }

    checkScreenWidth() {
        if (window.innerWidth < 768) { // Changer la condition pour < 768
            toggleSwiperArgsLogiciels(true, this);
        } else {
            toggleSwiperArgsLogiciels(false, this);
        }

        if (window.innerWidth <= 1199) {
            toggleSwiperActivityAreaPosts(true, this);
            toggleSwiperCtaServices(true, this);
            this.swiperCtaJobs.toggleSwiperCtaJobs(true);
        } else {
            toggleSwiperActivityAreaPosts(false, this);
            toggleSwiperCtaServices(false, this);
            this.swiperCtaJobs.toggleSwiperCtaJobs(false);
        }
    }
}

export default Sliders;
